enum ProcessType {
    Testing = 0,
    Process = 1
}

const ProcessTypeValue = {
    GetText: (typeNumber: number) => {
        return ProcessType[typeNumber].valueOf()
    }
}

export default ProcessTypeValue